import {useState, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import withStyles, {StyledComponentProps} from '@material-ui/core/styles/withStyles'

import {styles} from './styles'

function ExpirationTimer({classes = {}, maxAge}: StyledComponentProps & {maxAge: number}) {
  const [time, setTime] = useState(maxAge)
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(time - 1)
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [time])

  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time % 60

  if (time < 0) return <Redirect to="/" />

  return (
    <Typography className={classes.time}>
      {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:
      {seconds.toString().padStart(2, '0')}
    </Typography>
  )
}

export default withStyles(styles)(ExpirationTimer)
